import React, { ReactElement } from 'react';

// Components
import { Button } from 'components';
import { ModalCopyWidget } from 'components/machine-health';

// Types
import { WidgetTableDataItem } from 'types/machine-health';

interface CopyConfigurationActionsProps {
  copiedConfiguration: WidgetTableDataItem[] | undefined;
  copyConfiguration: () => void;
  copyModalOpen: boolean;
  hasWidgets?: boolean;
  onCopyFromSelectedMachine: (id: string) => void;
  openCopyModal: () => void;
  setCopyModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const CopyConfigurationActions = ({
  copiedConfiguration,
  copyConfiguration,
  copyModalOpen,
  hasWidgets,
  onCopyFromSelectedMachine,
  openCopyModal,
  setCopyModalOpen
}: CopyConfigurationActionsProps): ReactElement | null => {
  if (hasWidgets && !copiedConfiguration) {
    return null;
  }

  return (
    <>
      <Button
        disabled={!copiedConfiguration || copiedConfiguration.length === 0}
        onClick={() => copyConfiguration()}
        variant={'primary'}
        width="fit-content"
      >
        Save Configuration
      </Button>

      <Button onClick={openCopyModal} width="fit-content">
        Copy Configuration from Machine
      </Button>

      <ModalCopyWidget
        nextText="Copy"
        onSelectMachine={onCopyFromSelectedMachine}
        setVisible={setCopyModalOpen}
        visible={copyModalOpen}
      />
    </>
  );
};

export default CopyConfigurationActions;
